import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { documentWorkspacePath, type DocKey } from "../../automation/common/documentRegistry";

/**
 * 구 문서 경로 → 정본 경로(/crm/documents/:docKey) 리다이렉트.
 *
 * ★ search 와 hash 를 반드시 그대로 넘긴다.
 *   `<Navigate to="/crm/documents/quote" replace />` 처럼 문자열만 주면 쿼리가 **버려진다** —
 *   임베드 캡처(`?embedded=1&projectId=…&projectStepId=…&docKey=…&returnPath=…`)와
 *   이력 딥링크(`?documentHistoryId=…`)가 그대로 죽는다.
 *   그래서 문자열 대신 {pathname, search, hash} 객체로 넘기고, 구 경로 전부가 이 컴포넌트를 쓴다.
 */
export default function DocumentRouteRedirect({ docKey }: { docKey: DocKey }) {
  const location = useLocation();
  return (
    <Navigate
      to={{ pathname: documentWorkspacePath(docKey), search: location.search, hash: location.hash }}
      replace
    />
  );
}
